import React, { createContext, useContext, useCallback, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getLocale } from "./index";

const LanguageContext = createContext(null);

const FONT_LINKS = {
  ja: "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap",
  ko: "https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;500;700&display=swap",
  bg: "https://fonts.googleapis.com/css2?family=Manrope:wght@300;400;600;700&display=swap",
};

export const LanguageProvider = ({ lang, children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    localStorage.setItem("nortis-lang", lang);
    document.documentElement.lang = lang;
    const href = FONT_LINKS[lang];
    if (href && !document.getElementById(`nortis-font-${lang}`)) {
      const link = document.createElement("link");
      link.id = `nortis-font-${lang}`;
      link.rel = "stylesheet";
      link.href = href;
      document.head.appendChild(link);
    }
  }, [lang]);

  const t = useMemo(() => getLocale(lang), [lang]);

  const path = useCallback((to) => (to === "/" ? `/${lang}` : `/${lang}${to}`), [lang]);

  const switchLang = useCallback(
    (l) => {
      if (l === lang) return;
      localStorage.setItem("nortis-lang", l);
      const rest = location.pathname.replace(new RegExp(`^/${lang}(?=/|$)`), "");
      navigate(`/${l}${rest}${location.search}${location.hash}`);
    },
    [lang, location, navigate]
  );

  return (
    <LanguageContext.Provider value={{ lang, t, path, switchLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
